import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';
import { toCamelCase } from '../config/utils';

const getDefaultState = () => toCamelCase(window.wall.wallPaper || {});
// src: null,
// widthIn: null,
// heightIn: null

const wallPaper = createReducer(getDefaultState(), {
  [Constants.wallPaper.update]: (state, { src }) => ({
    ...state,
    src
  }),
  [Constants.wallPaper.add]: (state, { src, widthIn, heightIn }) => ({
    src, widthIn, heightIn
  }),
  [Constants.wallPaper.remove]: () => ({})
});

export default wallPaper;
